import { Descriptions, Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  Link, useNavigate } from "react-router-dom"; 
import InsideHeader from "../../../components/InsideHeader";
import svg38 from "../../../assets/svg/svg38.svg";
import MaterialIcon from "material-icons-react";
import { fetchCasualPaymentDetails, fetchStaffNetPays } from "../../../features/dropdown/dropdownSlice";
import { dateForHumans, formatMoney } from "../../../utils"; 
import svg56 from "../../../assets/svg/svg56.svg"; 
import FilterModalPaymentLines from "./FilterModalPaymentLines";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";

export default function PaymentLinesTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { casualPaymentDetails, loading, casualPaymentDetailsCount } = useSelector(
    (state) => state.dropdown
  );
  const { casualPaymentObj } = useSelector((state) => state.folder);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }
  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchStaffNetPays());
    await setFilters([]);
  };

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  
  const handleNdovu = async () => {
    navigate("/ndovu-pay");
  };
 

  const handleAdd =async ()=>{
    const res = await dispatch(
      save({
        cpId:casualPaymentObj?.cpId, 
        url: "hr/addLinesFromAttendance.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchCasualPaymentDetailsData(); 
      await handleCancel(); 
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  }

  const settingItemsQuickActions=[
    {
      key: "1",
      label: (
        <Link
          onClick={handleAdd}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
        Add Lines From Attendance
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleNdovu}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
       Initiate Ndovupay Payment
        </Link>
      ),
    },
     
  ]

  const columns = [
    {
      title: "Casual No #",
      dataIndex: "ppPfno",
      sorter: (a, b) => a.ppPfno.localeCompare(b.ppPfno),
    },
    {
      title: "Casual Name",
      dataIndex: "ppFullname",
      sorter: (a, b) => a.ppFullname.localeCompare(b.ppFullname),
    },
    {
      title: "Normal Hourly Rate",
      dataIndex: "itemname",
      sorter: (a, b) => a.itemname.localeCompare(b.itemname),
    },
    {
      title: "Overtime Hourly Rate",
      dataIndex: "fpPyear",
      sorter: (a, b) => a.fpPyear - b.fpPyear,
    },
    {
      title: "Normal Hours Worked",
      dataIndex: "fpPmonth",
      sorter: (a, b) => a.fpPmonth - b.fpPmonth,
    },
    
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchCasualPaymentDetailsData(page, size) {
    dispatch(
      fetchCasualPaymentDetails({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        cpId:casualPaymentObj?.cpId
      })
    );
  }

  useEffect(() => {
    fetchCasualPaymentDetailsData();
  }, []);

  const items = [
    {
      key: "1",
      label: "Payment No",
      children: casualPaymentObj?.cpCpno,
    },
    {
      key: "2",
      label: "Created Date",
      children:(
        <div>{dateForHumans(casualPaymentObj?.cpCreatedDate)}</div>
      ) 
    },
    {
      key: "3",
      label: "Payment Description",
      children: casualPaymentObj?.cpPaymentDesc,
    },
    {
      key: "4",
      label: "Work Start Date",
      children:(<div>{dateForHumans(casualPaymentObj?.cpWorkStartdate)}</div>),
    },
    {
      key: "5",
      label: "Work End Date",
      children:(<div>{dateForHumans(casualPaymentObj?.cpWorkEnddate)}</div>),
    },
    {
      key: "6",
      label: "Payment Status",
      children: casualPaymentObj?.cpStatus,
    },
    {
      key: "3",
      label: "Total Amount",
      children:(
        <div>{formatMoney(casualPaymentObj?.totalAmount)}</div>
      ),
    },
    
  ];

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Casual Payment Information"
        subtitle="Manage Casual Payment within your institution"
        back={true}
        title1="Casual Payments"
        title2="Payment Lines and Details"
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="mt-[1.25rem]">
            <Descriptions
              column={2}
              colon={false}
              title="Casual Payment Information"
              items={items}
            />
          </div>
          <div className="flex justify-between items-center">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Payment Lines Details
            </h3>
           
          </div>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="flex items-center">
              <span>
                {" "}
                <button
                  onClick={showModalFilter}
                  type="button"
                  className={`bg-transparent flex items-center gap-x-'1' ${
                    Object?.keys(formData)?.length > 0
                      ? "!text-[#5688E5]"
                      : "inherit"
                  }`}
                >
                  <MaterialIcon color="#141414" icon="filter_list" />
                  Filters
                </button>
              </span>
              {Object?.keys(formData)?.length > 0 && (
                <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                  :{Object?.keys(formData)?.length}
                  <img src={svg38} alt="svg38" onClick={handleClearFilters} />
                </span>
              )}
            </div>

            <Dropdown
                overlayStyle={{
                  width: "250px",
                }}
                trigger={"click"}
                menu={{ items: settingItemsQuickActions }}
                placement="bottom"
              >
                <div className="w-[250px]">
                  <button className="cstm-btn flex gap-x-2" type="submit">
                  <img src={svg56} alt={svg56}/>  Quick actions
                  </button>
                </div>
              </Dropdown>

        
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.ptId}
                columns={columns}
                dataSource={casualPaymentDetails}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: casualPaymentDetailsCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchCasualPaymentDetailsData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <FilterModalPaymentLines
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
        year={casualPaymentObj?.fpPyear}
        month={casualPaymentObj?.fpPmonth}
      />
    </div>
  );
}
